import React from "react";
import VectorTypeSetting from "./VectorTypeSetting.jsx";
import GeojsonTypeSetting from "./GeojsonTypeSetting.jsx";
import RasterTypeSetting from './RasterTypeSetting.jsx';

const DATA_SOURCE_OPTIONS = [
    { value: 'geojson', label: I18n.t('geojson') },
    { value: 'vector', label: I18n.t('vector')},
    { value: 'raster', label: I18n.t('raster')},
]

export const SOURCE_PROPS = {
    type: {
        type: "enum",
        title: I18n.t('source_type'),
        description: I18n.t('mapbox_source_type'),
        default: "geojson",
        options: DATA_SOURCE_OPTIONS,
        optional: false
    },
    label: {
        description: I18n.t('mapbox_source_id'),
        default: StringHelper.random(8),
        optional: false,
        title: I18n.t("label")
    },
    advancedSetting: {
        type: "json",
        description: I18n.t('mapbox_custom_settings'),
        title: I18n.t('advanced_settings')
    },
    vector: {
        tiles: {
            type: "string_array", //comma separated
            optional: false,
            description: I18n.t('mapbox_source_tiles'),
            title: I18n.t('tiles'),
            default: ""
        },
        minzoom: {
            type: "number",
            default: 0,
            max: "maxzoom",
            optional: true,
            description: I18n.t('mapbox_source_min_zoom'),
            title: I18n.t('min_zoom')
        },
        maxzoom: {
            type: "number",
            default: 22,
            max: 22,
            min: "minzoom",
            optional: true,
            description: I18n.t('mapbox_source_max_zoom'),
            title: I18n.t('max_zoom')
        }
    },
    geojson: {
        data: {
            optional: true,
            description: I18n.t('mapbox_source_geojson_url'),
            type: "string",
            title: I18n.t('mapbox_datasource'),
            default: ""
        },
        cluster: {
            default: false,
            type: "boolean",
            description: I18n.t('mapbox_source_cluster'),
            optional: true,
            title: I18n.t('geojson_cluster')
        },
        clusterRadius: {
            type: "number",
            default: 50,
            min: 0,
            description: I18n.t('mapbox_source_cluster_radius'),
            optional: true,
            title: I18n.t('cluster_radius')
        },
        clusterMaxZoom: {
            type: "number",
            default: 17, // Need a formula because it need to be "maxzoom -1"
            max: 17,
            min: 0,
            description: I18n.t('mapbox_source_cluster_max_zoom'),
            title: I18n.t('cluster_max_zoom')
        }
    },
    raster: {
        tiles: {
            type: "string_array", //comma separated
            optional: false,
            description: I18n.t('mapbox_source_tiles'),
            title: I18n.t('tiles'),
            default: ""
        },
        minzoom: {
            type: "number",
            default: 0,
            max: "maxzoom",
            optional: true,
            description: I18n.t('mapbox_source_min_zoom'),
            title: I18n.t('min_zoom')
        },
        maxzoom: {
            type: "number",
            default: 22,
            max: 22,
            min: "minzoom",
            optional: true,
            description: I18n.t('mapbox_source_max_zoom'),
            title: I18n.t('max_zoom')
        }
    }
};

export const SOURCE_TYPE_MAP = {
    vector: (updateField, sourceField, index) => {return <VectorTypeSetting updateField={updateField} sourceField={sourceField} index={index} />},
    geojson: (updateField, sourceField, index) => {return <GeojsonTypeSetting updateField={updateField} sourceField={sourceField} index={index}  />},
    raster: (updateField, sourceField, index) => {return <RasterTypeSetting updateField={updateField} sourceField={sourceField} index={index}  />}
}

export const DND_SOURCE_FIELD = 'source-row';